import {
  ForgotPasswordMethod,
  IOTPState,
  IOTPTimerProps,
  IOTPCounterProps,
  IOTPLockProps,
} from 'src/shared/interface/forgot-password';
import { OTPInput } from '../components/OTPInput';
import { useOTPStep } from '../steps/otpStep';

interface IOTPStepContainerProps {
  method: ForgotPasswordMethod;
  username: string;
  identifier: string;
  otpState: IOTPState;
  onSuccess: (otp: string, token: string) => void;
  onOTPStateChange: (state: Partial<IOTPState>) => void;
  onBack: () => void;
}

export const OTPStepContainer = ({
  method,
  username,
  identifier,
  otpState,
  onSuccess,
  onOTPStateChange,
  onBack,
}: IOTPStepContainerProps) => {
  const {
    loading,
    otpExpiryTimer,
    verifyLockTimer,
    resendLockTimer,
    handleOTPComplete,
    handleResendOTP,
    canResend,
    remainingVerifyAttempts,
  } = useOTPStep({
    method,
    username,
    identifier,
    otpState,
    onSuccess,
    onOTPStateChange,
  });

  const isBlockedByAPI = otpState.isBlock === true;
  const blockCountdown = otpState.countdownTimeInSecond ?? 0;

  const resendCooldownTime =
    otpState.countdownTimeInSecond && otpState.countdownTimeInSecond > 0
      ? otpState.countdownTimeInSecond
      : 0;

  const timers: IOTPTimerProps = {
    otpExpiry: otpExpiryTimer.timeLeft,
    resendCooldown: resendCooldownTime,
    verifyLock: isBlockedByAPI && blockCountdown > 0 ? blockCountdown : verifyLockTimer.timeLeft,
    resendLock: resendLockTimer.timeLeft,
  };

  const counters: IOTPCounterProps = {
    verifyAttempts: otpState.verifyAttempts,
    remainingVerifyAttempts,
    currentResendCount: otpState.resendCount,
    maxResendCount: otpState.maxResendCount,
  };
  const locks: IOTPLockProps = {
    isVerifyLocked: isBlockedByAPI || otpState.isVerifyLocked,
    isResendLocked: otpState.isResendLocked,
  };
  return (
    <OTPInput
      method={method}
      identifier={identifier}
      timers={timers}
      counters={counters}
      locks={locks}
      loading={loading}
      canResend={canResend}
      onOTPComplete={handleOTPComplete}
      onResend={handleResendOTP}
      onBack={onBack}
    />
  );
};
